import _ from 'lodash';
import React from 'react';
import { components } from '@glowforge/ui-common';

const { Tooltip } = components;

export const renderMachineCell = (machines) => { // eslint-disable-line
  if (machines.length <= 3) {
    return _.map(machines, m => m.machineName).join(' & ');
  }
  const list = _.map(machines, m => <div>{m.machineName}</div>);
  return (
    <Tooltip infoText={list}>
      <span>{`${machines.length} printers`}</span>
    </Tooltip>
  );
};



// WEBPACK FOOTER //
// ./app/components/settings/machine-cell.jsx